"use strict";

if (document.getElementById("js-search")) {
  window.vueSearch = new Vue({
    delimiters: ['[[', ']]'],
    el: '#js-search',
    data: {
      search: '',
      results: [],
      posts: {
        total: 0,
        items: []
      },
      events: {
        total: 0,
        items: []
      },
      challenges: {
        total: 0,
        items: []
      },
      knowledges: {
        total: 0,
        items: []
      },
      lawyers: {
        total: 0,
        items: []
      },
      zoomons: {
        total: 0,
        items: []
      },
      timeout: 0,
      loading: false,
      lang: document.getElementById('js-search').getAttribute('data-lang')
    },
    mounted: function mounted() {},
    computed: {},
    methods: {
      /***********************************
      GET DATA
      ***********************************/
      searchPages: function searchPages() {
        var _this = this;

        var client = algoliasearch('OYCARYZD8D', '189e774eb6f8a10e7628d1f247454b63');
        var index_posts = client.initIndex(this.lang + '_POST');
        var index_lawyers = client.initIndex(this.lang + '_LAWYER');
        var index_events = client.initIndex(this.lang + '_EVENT');
        var index_knowledges = client.initIndex(this.lang + '_KNOWLEDGE');
        var index_challenges = client.initIndex(this.lang + '_CHALLENGE');
        var index_zoomons = client.initIndex(this.lang + '_ZOOMON');
        var value = this.search;
        clearTimeout(this.timeout);

        if (value != '') {
          this.loading = true;
        } else {
          this.loading = false;
        }

        this.timeout = setTimeout(function () {
          if (value != '') {
            var val = value;
            index_posts.search(val, {
              hitsPerPage: 1000
            }).then(function (_ref) {
              var hits = _ref.hits;
              _this.posts.total = hits.length;
              _this.posts.items = hits;
            })["catch"](function (errors) {
              console.log(errors);
            });
            index_lawyers.search(val, {
              hitsPerPage: 1000
            }).then(function (_ref2) {
              var hits = _ref2.hits;
              _this.lawyers.total = hits.length;
              _this.lawyers.items = hits;
            })["catch"](function (errors) {
              console.log(errors);
            });
            index_events.search(val, {
              hitsPerPage: 1000
            }).then(function (_ref3) {
              var hits = _ref3.hits;
              _this.events.total = hits.length;
              _this.events.items = hits;
            })["catch"](function (errors) {
              console.log(errors);
            });
            index_knowledges.search(val, {
              hitsPerPage: 1000
            }).then(function (_ref4) {
              var hits = _ref4.hits;
              _this.knowledges.total = hits.length;
              _this.knowledges.items = hits;
            })["catch"](function (errors) {
              console.log(errors);
            });
            index_challenges.search(val, {
              hitsPerPage: 1000
            }).then(function (_ref5) {
              var hits = _ref5.hits;
              _this.challenges.total = hits.length;
              _this.challenges.items = hits;
            })["catch"](function (errors) {
              console.log(errors);
            });
            index_zoomons.search(val, {
              hitsPerPage: 1000
            }).then(function (_ref6) {
              var hits = _ref6.hits;
              _this.zoomons.total = hits.length;
              _this.zoomons.items = hits;
            })["catch"](function (errors) {
              console.log(errors);
            });
          } else {
            _this.results = [];
          }

          _this.loading = false;
        }, 500);
      },
      bindEsc: function bindEsc(event) {
        if (event.keyCode == 27) {
          if (this.search != '') {
            this.clear();
          } else {
            toggleSearch();
          }
        }
      },
      clean: function clean(data) {
        return data.filter(function (result) {
          return result.language == window.currentLanguage;
        });
      },
      clear: function clear() {
        this.search = '';
        this.searchPages();
      },
      getItemURL: function getItemURL(item) {
        return item['url_' + this.lang];
      },
      getJob: function getJob(item) {
        return item['_highlightResult']['job_index_' + this.lang] ? item['_highlightResult']['job_index_' + this.lang]['value'] : '-';
      },
      getExpertise: function getExpertise(item) {
        return item['_highlightResult']['expertises_index_' + this.lang] ? item['_highlightResult']['expertises_index_' + this.lang]['value'] : '-';
      },
      getTitle: function getTitle(item) {
        return item['_highlightResult']['title_' + this.lang] ? item['_highlightResult']['title_' + this.lang]['value'] : '-';
      },
      getSubtitle: function getSubtitle(item) {
        return item['_highlightResult']['subtitle_' + this.lang] ? item['_highlightResult']['subtitle_' + this.lang]['value'] : '-';
      },
      getName: function getName(item) {
        return item['_highlightResult']['name_' + this.lang] ? item['_highlightResult']['name_' + this.lang]['value'] : '-';
      },
      getLawyerName: function getLawyerName(item) {
        return item['_highlightResult']['first_name']['value'] + ' ' + item['_highlightResult']['last_name']['value'];
      }
    }
  });
}

function toggleSearch() {
  var search = document.querySelector('#js-search');
  var header = document.querySelector('.js-header');
  var menu = document.querySelector('.js-menu');
  var input = search.querySelector('input');
  search.classList.toggle('is-open');
  header.classList.toggle('has-search-open');
  header.classList.remove('has-menu-open');
  menu.classList.remove('is-open');

  if (search.classList.contains('is-open')) {
    setTimeout(function () {
      input.focus();
    }, 1000);
  } else {
    window.vueSearch.clear();
  }
}